const sexEnum = {
  F: {
    label: 'Feminino',
    ageLimit: 45,
  },
  M: {
    label: 'Masculino',
    ageLimit: 50,
  },
}

export default sexEnum
